import React from 'react';
import { Tag } from 'antd';
import classes from './Status.module.scss';
import cn from 'classnames';

const DEFAULT_COLORS = {
  default: 'default',
  success: 'success',
  error: 'error',
  warning: 'warning',
  processing: 'processing',
};

const DEFAULT_OPTIONS = [
  {
    key: 'pass',
    label: 'Pass',
    color: DEFAULT_COLORS.success,
    icon: null,
  },
  {
    key: 'fail',
    label: 'Fail',
    color: DEFAULT_COLORS.error,
    icon: null,
  },
  {
    key: 'reportAsIs',
    label: 'Report As Is',
    color: DEFAULT_COLORS.default,
    icon: null,
  },
  {
    key: 'n/a',
    label: 'N/A',
    color: DEFAULT_COLORS.default,
    icon: null,
  },
];

export default ({ value, type = 'tag', ghost = true, options = DEFAULT_OPTIONS }) => {
  const status = options.find((option) => option.key === value);
  if (!status) return 'N/A';
  const { icon } = status;
  if (type === 'text') {
    return (
      <Tag
        color={status.color}
        className={cn(classes.status, classes.text, {
          [classes.ghost]: ghost,
          [classes.hasIcon]: !!icon,
        })}>
        {icon && <span className={classes.icon}>{icon}</span>}
        {status.label}
      </Tag>
    );
  }
  // TODO: If you have other types of status, you can add them here
  return (
    <Tag
      className={cn(classes.status, {
        [classes.hasIcon]: !!icon,
      })}
      color={status.color}>
      {icon && <span className={classes.icon}>{icon}</span>}
      {status.label}
    </Tag>
  );
};
